import type { ReactNode } from 'react';

import { FormLabel, Stack } from '@mui/material';

import { ChipSelectorButton } from './chip-selector.styled';

type ChipSelectorOption = {
  label: string;
  value: string;
};

export type ChipSelectorProps = {
  value: string;
  onChange: (value: string) => void;
  options: ChipSelectorOption[];
  label?: string;
  required?: boolean;
  rightElement?: ReactNode;
};

export const ChipSelector = (props: ChipSelectorProps) => {
  const { value, onChange, options, label, required, rightElement } = props;

  return (
    <Stack gap={0.75}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <Stack direction="row" gap={1} flexWrap="nowrap">
        {options.map((option) => (
          <ChipSelectorButton
            key={option.value}
            selected={value === option.value}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </ChipSelectorButton>
        ))}
        {rightElement}
      </Stack>
    </Stack>
  );
};
